import React from 'react';
import { connect } from 'react-redux';
import * as actions from '../Store/actions';

import StackList from '../UI/StackList';

const offersForm = (props) => {

	let accept_last_primary = null;
	if(props.offers_primary.length && !props.matter.offer_accepted)
		accept_last_primary = <span className='field__btn' onClick={() => props.rdxSetModal('accept_offer')}>Accept last</span>;
	else if(props.offers_primary.length && props.matter.offer_accepted === 'primary')
		accept_last_primary = <span className='field__btn field__btn--grey' onClick={() => props.rdxSetModal('decline_offer')}>Renounce offer</span>;

	let accept_last_counter = null;
	if(props.offers_counter.length && !props.matter.offer_accepted)
		accept_last_counter = <span className='field__btn' onClick={() => props.rdxSetModal('accept_counter')}>Accept last</span>;
	else if(props.offers_counter.length && props.matter.offer_accepted === 'counter')
		accept_last_counter = <span className='field__btn field__btn--grey' onClick={() => props.rdxSetModal('decline_counter')}>Renounce offer</span>;

	let classes = 'matter-form';
	if(props.size === 'small')
		classes += ' matter-form--small';

	let note = null;
	if(props.matter.offer_accepted)
		note = <div className='field__note'><p className='field__note__content'>* Offer accepted</p></div>;

	return (
		<div className={classes}>
			<div className='field'>
				<h3>Offers{accept_last_primary}</h3>
				<StackList context='primary' data={props.offers_primary} locked={props.matter.offer_accepted ? true : false} />
			</div>
			<div className='field'>
				<h3>Counter Offers{accept_last_counter}</h3>
				<StackList context='counter' data={props.offers_counter} locked={props.matter.offer_accepted ? true : false} />
			</div>
			{note}
		</div>
	);

}


const mapStateToProps = state => {
	return {
		matter: state.matter,
		offers_primary: state.offers_primary,
		offers_counter: state.offers_counter
	};
}

const mapDispatchToProps = dispatch => {
	return {
		rdxSetModal: (content) => dispatch(actions.setModal(content))
	};
}


export default connect(mapStateToProps,mapDispatchToProps)(offersForm);


// WEBPACK FOOTER //
// ./src/Blocks/OffersForm.js